
const encryptDafaultState = {
    fileForDecrypt: null,
    fileForDecryptName: "",
    fileForDecryptSelected: false,
    decrData: null
}

const decryptReducer = (state = encryptDafaultState, { type, payload }) => {

    switch (type) {
    	case "SET_INPUT_FILE_FOR_DECRYPT": {
		    return {
		        ...state,
		        fileForDecrypt: payload,
		        fileForDecryptName: payload.name,
		        fileForDecryptSelected: true,
		    }
		}

		case "CLEAR_INPUT_FILE_FOR_DECRYPT": {
		    return {
		        ...state,
		        fileForDecrypt: null,
		        fileForDecryptName: "",
		        fileForDecryptSelected: false,
		    }
		}

        case 'SET_DECRYPTED_DATA': {
            return {
                ...state,
                decrData: payload
            }
        }

        case 'CLEAR_DECRYPTED_DATA': {
            return {
                ...state,
                decrData: null
            }
        }

        default:
            return state;
    }

}

export default decryptReducer